import { render } from "./DashboardTabTotals.vue?vue&type=template&id=8546964c&scoped=true&ts=true"
import script from "./DashboardTabTotals.vue?vue&type=script&lang=ts"
export * from "./DashboardTabTotals.vue?vue&type=script&lang=ts"

import "./DashboardTabTotals.vue?vue&type=style&index=0&id=8546964c&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8546964c"]])

export default __exports__